// @flow

/**
 * Module dependencies.
 */

import { breakpoints } from 'client/styles/layout';
import { css } from 'styled-components';
import { join } from 'lodash';

/**
 * Create media queries for each breakpoint.
 */

function createMediaQueries(query: Function, breakpoints: Object): Object {
  return Object
    .keys(breakpoints)
    .reduce((result: Object, breakpoint: string): Object => ({
      ...result,
      [`${breakpoint}Query`]: (...args: any): any => `${query(breakpoints[breakpoint])}{${join(args)}}`,
      [breakpoint]: (...args: any): any => css`${query(breakpoints[breakpoint])}{${css(...args)}}`
    }), {});
}

/**
 * Export `createMediaQuery`.
 */

export function createMediaQuery(boundType: string, compensation: number = 0): Function {
  return (breakpoint: number): string => `@media (${boundType}: ${breakpoint + compensation}px)`;
}

/**
 * Export `createMediaQueryOrientation`.
 */

export function createMediaQueryOrientation(boundType: string): Function {
  return (breakpoint: number): string => `@media (max-width: ${breakpoint}px) and (orientation: ${boundType})`;
}

/**
 * Export `maxWidth`.
 */

export const maxWidth = createMediaQuery('max-width', -1);

/**
 * Export `minWidth`.
 */

export const minWidth = createMediaQuery('min-width');

/**
 * Export `landscape`.
 */

export const landscape = createMediaQueryOrientation('landscape');

/**
 * Export `portrait`.
 */

export const portrait = createMediaQueryOrientation('portrait');

/**
 * Export `media`.
 */

export const media = {
  landscape: createMediaQueries(landscape, breakpoints),
  max: createMediaQueries(maxWidth, breakpoints),
  min: createMediaQueries(minWidth, breakpoints),
  portrait: createMediaQueries(portrait, breakpoints)
};



// WEBPACK FOOTER //
// ../src/client/styles/responsive.js